import { BaseService } from './BaseService';
export interface IndexNowStatus {
  Enabled: boolean;
  Pending: number;
  Failed: number;
  LastAcceptedUtc: string | null;
  Message: string;
}
export class IndexNowService extends BaseService {
  status = (siteId: string) => this._ajaxService.Get<IndexNowStatus>(`/IndexNow/Status/${siteId}`, true, undefined, undefined, true);
  submitPublished = (siteId: string) => this._ajaxService.Post<{ Status: string; PageCount: number }>(`/IndexNow/SubmitPublished/${siteId}`, {}, true);
}
